export type PlanStatus = 'free' | 'lifetime' | 'pro' | 'pro_cancelled' | 'appsumo_tier1' | 'appsumo_tier2' | 'appsumo_tier3';

export interface PlanLimits {
  maxRequestsPerMonth: number;
  maxStaff: number;
  canUploadPhotos: boolean;
}

// Keep in sync with server/lib/planLimits.ts
export const PLAN_LIMITS: Record<PlanStatus, PlanLimits> = {
  free: {
    maxRequestsPerMonth: 10,
    maxStaff: 1,
    canUploadPhotos: false,
  },
  lifetime: {
    maxRequestsPerMonth: 500,
    maxStaff: Infinity,
    canUploadPhotos: true,
  },
  pro: {
    maxRequestsPerMonth: Infinity,
    maxStaff: Infinity,
    canUploadPhotos: true,
  },
  pro_cancelled: {
    maxRequestsPerMonth: Infinity,
    maxStaff: Infinity,
    canUploadPhotos: true,
  },
  appsumo_tier1: {
    maxRequestsPerMonth: 500,
    maxStaff: Infinity,
    canUploadPhotos: true,
  },
  appsumo_tier2: {
    maxRequestsPerMonth: 1000,
    maxStaff: Infinity,
    canUploadPhotos: true,
  },
  appsumo_tier3: {
    maxRequestsPerMonth: Infinity,
    maxStaff: Infinity,
    canUploadPhotos: true,
  },
};

export function getPlanLimits(planType: string): PlanLimits {
  return PLAN_LIMITS[planType as PlanStatus] || PLAN_LIMITS.free;
}

export function getPlanDisplayName(planType: string): string {
  switch (planType) {
    case 'lifetime':
      return 'Lifetime';
    case 'pro':
      return 'Pro';
    case 'pro_cancelled':
      return 'Pro (Cancelled)';
    case 'appsumo_tier1':
      return 'AppSumo Tier 1';
    case 'appsumo_tier2':
      return 'AppSumo Tier 2';
    case 'appsumo_tier3':
      return 'AppSumo Tier 3';
    default:
      return 'Free';
  }
}

export function isAppSumoPlan(planType: string): boolean {
  return planType.startsWith('appsumo_');
}
